import React from "react";
import Layout from "../../../../Components/Common/Layout";
import DashLayout from "../../../../Components/Admin/AdminDashLayout";
import LiabilitiesTable from "./LiabilitiesTable";
import useNavHeading from "../../../../Hooks/CommonHooks/useNavHeading ";
import ProtectedSection from "../../../../Routes/ProtectedRoutes/ProtectedSection.js";
import { PERMISSIONS } from "../../../../config/permission";

const LiabilitiesMain = () => {
  useNavHeading("Finance", `Liabilities`);

  return (
    <Layout title={"Liabilities | Office Flow"}>
      <DashLayout>
        <ProtectedSection requiredPermission={PERMISSIONS.VIEW_LIABILITIES} title={"Liabilites"}>
          <LiabilitiesTable />
        </ProtectedSection>
      </DashLayout>
    </Layout>
  );
};

export default LiabilitiesMain;